import axios from "axios";
import { environment } from './environments/environment.js';
import DocumentsService from "../services/documents.service";


const tokenApi = environment.patovik_url
const refreshToken = environment.refreshToken

if(localStorage.getItem('token') === null){
  DocumentsService.generateToken()
}

const krakenApi = axios.create({
  baseURL: environment.kraken_url,
});

const poirotApi = axios.create({
  baseURL: environment.poirot_url,
});

const patovikApi = axios.create({
  baseURL: environment.patovik_url,
});

export { krakenApi, poirotApi, patovikApi, tokenApi, refreshToken };